import { NgModule } from '@angular/core';

import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { HttpClientModule } from '@angular/common/http';
import { LogEngineService } from './services/log-engine/log-engine.service';
import { NotFoundComponent } from './features/not-found/not-found.component';
import { PathResolveService } from './services/path-resolve/path-resolve-service.service';
import { LocalStatusBarService } from './services/status-service/local-status-bar.service';

export const firebaseCredential = {
  apiKey: "AIzaSyCNA7twaZuZHvxAkX35Gz0QoZH8CCyvp9A",
  authDomain: "mobidawg-llc.firebaseapp.com",
  databaseURL: "https://mobidawg-llc.firebaseio.com",
  projectId: "mobidawg",
  storageBucket: "mobidawg-llc.appspot.com",
  messagingSenderId: "975636230396"
}

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent
  ],
  imports: [
    CoreModule, 
    SharedModule,
    AngularFireModule.initializeApp(firebaseCredential),
    AngularFireAuthModule,
    AppRoutingModule,
    HttpClientModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
  ],
  providers: [LogEngineService, PathResolveService, LocalStatusBarService],
  bootstrap: [AppComponent]
})
export class AppModule { }
